export default "__VITE_ASSET__bFsMnH31__"